export default (endValue) => ({
  startValue: 0,
  currentValue: 0,
  endValue,            // raw input (may contain commas)
  numericEndValue: 0,  // cleaned number
  isVisible: false,
  startTime: 0,
  animationFrameId: null,
  formattedValue: '0',

  init() {
    // Convert "13,625" → 13625
    this.numericEndValue = Number(String(this.endValue).replace(/,/g, ''));

    this.$watch("isVisible", (isVisible) => {
      if (isVisible && this.startValue === this.currentValue) {
        this.startTime = performance.now();
        this.animateCount();
      }
    });
  },

  animateCount() {
    const currentTime = performance.now();
    const elapsed = currentTime - this.startTime;

    if (elapsed < 1000) {
      this.currentValue = Math.round((elapsed / 1000) * this.numericEndValue);
      this.formattedValue = this.currentValue.toLocaleString();
      this.animationFrameId = requestAnimationFrame(() => this.animateCount());
    } else {
      this.currentValue = this.numericEndValue;
      this.formattedValue = this.numericEndValue.toLocaleString();
      cancelAnimationFrame(this.animationFrameId);
    }
  },
});
